<div class="row">
  <div class="{{groupClass}}">
  <div class="form-group">
    <label for="paquete" class="label">Paquete
      <a *ngIf="icon.pack == 'eva'" href ="https://akveo.github.io/eva-icons/#/" target="_blank">Ver</a>
      <a *ngIf="icon.pack == 'font-awesome'" href ="https://fontawesome.com/v5/search?m=free" target="_blank">Ver</a>
    </label>
    <nb-select placeholder="Paquete de iconos" fullWidth name="paquete" [(ngModel)]="icon.pack">
      <nb-option [value]="item" *ngFor="let item of packs">{{item}}</nb-option>
    </nb-select>
    </div>

  </div>
  <div class="{{groupClass}}">
    <div class="form-group">
      <label for="icono" class="label">Icono <nb-icon *ngIf="icon.pack == 'eva'" [icon]="icon.icon"></nb-icon><nb-icon *ngIf="icon.pack == 'font-awesome'" [icon]="icon.icon" pack="font-awesome"></nb-icon></label>
      <input type="text" nbInput fullWidth name="icono" [(ngModel)]="icon.icon"/>
    </div>
  </div>

</div>

